module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Plus-7ad660eaf4407db38ccca917e1a2abc1.svg";